export default "__VITE_ASSET__COF5kRzD__"